import { render } from "./AddressDetails.vue?vue&type=template&id=3f050ab5&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import "./AddressDetails.vue?vue&type=style&index=0&id=3f050ab5&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f050ab5"]])

export default __exports__